import {
  convertStatus,
  convertStatusUrl,
  Status,
} from '../../../../api/enumerations';
import {
  GetAllWorkOrderDataProps,
  GetTopWorkOrdersData,
  WorkOrderData,
} from '../../../../api/workOrders/types';
import { Column } from '../../Column';
import { PipelineContainer } from '../../styles';

interface PipelineViewProps {
  pipelineData: GetAllWorkOrderDataProps | GetTopWorkOrdersData | undefined;
  pipelineLoading: boolean;
  isSearching: boolean;
}

const PIPELINE_STATUSES: Status[] = [
  Status.ENTRANCE,
  Status.PEPT,
  Status.SCHEDULE,
  Status.INSPECTION,
  Status.SAMPLE_CREATION,
  Status.CALCULATION,
  Status.REPORT,
  Status.REVISION,
];

interface ColumnEntry {
  id: string;
  name: string;
  workOrders: WorkOrderData[] | undefined;
  link: string;
  status: Status;
  totalRecords: number | undefined;
}

const buildColumns = (
  data: GetAllWorkOrderDataProps | GetTopWorkOrdersData | undefined
): ColumnEntry[] =>
  PIPELINE_STATUSES.map((status) => {
    const slice = data?.[status];
    const isTopShape = !!slice && typeof slice === 'object' && 'items' in slice;
    return {
      id: convertStatusUrl(status),
      name: convertStatus(status),
      workOrders: isTopShape
        ? (slice as { items?: WorkOrderData[] }).items
        : (slice as WorkOrderData[] | undefined),
      link: convertStatusUrl(status),
      status,
      totalRecords: isTopShape
        ? (slice as { total_records?: number }).total_records
        : undefined,
    };
  });

export function PipelineView({
  pipelineData,
  pipelineLoading,
  isSearching,
}: PipelineViewProps): JSX.Element {
  const columns = buildColumns(pipelineData);

  return (
    <PipelineContainer>
      {columns.map((column) => (
        <Column
          key={column.id}
          columnData={{
            name: column.name,
            workOrders: column.workOrders ?? [],
            link: column.link,
            status: column.status,
            totalRecords: column.totalRecords,
          }}
          pipelineLoading={pipelineLoading}
          isSearching={isSearching}
        />
      ))}
    </PipelineContainer>
  );
}
